import moment from "moment";
import DayjsExtended from "@logic/DayjsExtended";

export default {
  // Returns a date with the days added to the passed date.
  // NOTE: Does not modify the passed date
  addDays(input: Date, daysToAdd: number) {
    const date = new Date(input);
    date.setDate(date.getDate() + daysToAdd);
    return date;
  },

  daysBetween(startDate: Date, endDate: Date) {
    var msPerDay = 24 * 60 * 60 * 1000;
    var diff = this.getUTC(endDate) - this.getUTC(startDate);
    return diff / msPerDay;
  },

  getUTC(input): any {
    var date = new Date(input);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  },

  formatDateRangeTwoDates(startDateString: string, endDateString: string, includeYear = true): string {
    if (!startDateString || startDateString.length === 0) return "";

    const startDate = new Date(startDateString);
    let result = moment(startDate).format("MMM Do");
    if (endDateString !== startDateString) {
      const differentMonth = startDate.getMonth() !== new Date(endDateString).getMonth();
      const endDate = new Date(endDateString);
      const format = (differentMonth ? "MMM " : "") + "Do" + (includeYear ? ", YYYY" : "");
      result += " - " + moment(endDate).format(format);
    }
    return result;
  },

  formatDateRange(startDateString: string, daysToAdd = 0, includeYear = true, format = ""): string {
    if (!startDateString || startDateString.length === 0) return "";

    const startDate = new Date(startDateString);
    const _format = format || "MMM Do" + (daysToAdd === 0 && includeYear ? ", YYYY" : "");
    let result = moment(startDate).format(_format);
    if (daysToAdd > 0) {
      const endDate = this.addDays(startDate, daysToAdd);
      const differentMonth = startDate.getMonth() !== endDate.getMonth();
      const _format = format || (differentMonth ? "MMM " : "") + "Do" + (includeYear ? ", YYYY" : "");
      result += " - " + moment(endDate).format(_format);
    }
    return result;
  },

  forceToNoonUTC(date: Date): Date {
    // Repeated other places DatePicker is used
    // Note: Previously we were using setUTCHours(12) but that was causing the date to be off by a day
    // Have to use Date.UTC or it will adjust hours to local time
    const local = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 11, 11));
    return local;
  },

  /**
   * Converts "2025-W1" to "Dec 30 2024 – Jan 5 2025"
   */
  yearWeekToDateRange(weekString: string, formatting = "MMM D YYYY"): string {
    const [year, weekPart] = weekString.split("-");
    const weekNumber = parseInt(weekPart.substring(1));

    // Monday
    const startOfWeek = DayjsExtended().year(parseInt(year)).isoWeek(weekNumber).startOf("isoWeek");
    // Sunday
    const endOfWeek = startOfWeek.endOf("isoWeek");

    const startFormatted = startOfWeek.format(formatting);
    const endFormatted = endOfWeek.format(formatting);

    return `${startFormatted} — ${endFormatted}`;
  },

  shortenMonthNamesInString(stringWithMonthNames: string) {
    const map = {
      january: "Jan",
      february: "Feb",
      march: "Mar",
      april: "Apr",
      may: "May",
      june: "Jun",
      july: "Jul",
      august: "Aug",
      september: "Sep",
      october: "Oct",
      november: "Nov",
      december: "Dec",
    };

    const regex = /\b(January|February|March|April|May|June|July|August|September|October|November|December)\b/gi;

    return stringWithMonthNames.replace(regex, match => map[match.toLowerCase()]);
  },
};
